import { SIGNALR_CONNECTED_TYPE, SIGNALR_INVOKE_TYPE, SIGNALR_START_TYPE } from 'services/signalR.types';

export default {
  SIGNALR_START: SIGNALR_START_TYPE,
  SIGNALR_CONNECTED: SIGNALR_CONNECTED_TYPE,
  SIGNALR_INVOKE: SIGNALR_INVOKE_TYPE,
  SIGNALR_INCOME_RECEIVE: 'SIGNALR_INCOME/quoteSymbol-receive',
  SIGNALR_WALLET_BALANCE_UPDATED: 'SIGNALR_INCOME/ReceiveMessage/CustomerBalanceUpdated',
  SIGNALR_WALLET_BALANCE_TRANSACTION_EVENT: 'SIGNALR_INCOME/ReceiveMessage/AccountTransactionEvent',
  SIGNALR_WALLET_BALANCE_UPDATED_SUCCESS: 'SIGNALR_INCOME_WALLET_BALANCE_UPDATED_SUCCESS',
  SIGNALR_INCOME_RECEIVE_LASTPRICE: 'SIGNALR_INCOME/trading-pair-price-receive-lastprice',
  SIGNALR_INCOME_RECEIVE_BESTBID: 'SIGNALR_INCOME/trading-pair-price-receive-bestbid',
  SIGNALR_INCOME_RECEIVE_BESTASK: 'SIGNALR_INCOME/trading-pair-price-receive-bestask',

  SIGNALR_TRANSFER_UPDATED: 'SIGNALR_INCOME/TransferStatusUpdated',
} as const;
